<template>
  <div class="category-list menu">
    <h4>Categories</h4>
    <input type="checkbox" name="list-toggler" id="list-toggler" class="hidden">
    <label for="list-toggler" class="list-toggler"></label>

    <loader v-if="loading" />
    <ul class="list-wrapper no-padding" v-else>
      <li
        v-for="category in computedCategory"
        :key="category.id"
        class="item"
        :id="category.id"
        :ref="`category-${category.id}`"
      >
        <a
          class="btn clickable"
          @click="setActiveCategory(category.id)"
        >
          {{ category.name }}
        </a>
        <div class="sub-menu">
          <a
            v-for="sub in category.nodes"
            :key="sub.id"
            class="clickable"
            :ref="`subcategory-${sub.id}`"
            @click="setActiveSubCategory(sub.id)"
          >&nbsp;&nbsp;&nbsp;&nbsp;{{ sub.name }}</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CategoryList',
  data () {
    return {
      categories: [],
      loading: true,
      curCat: 0
    }
  },
  computed: {
    computedCategory () {
      this._(this.categories).forEach(f => {
        f.nodes = this._(this.categories).filter(g => g.parent == f.id).value()
      })
      var resultArray = this._(this.categories).filter(f => f.parent == null).value()
      return resultArray
    }
  },
  created () {
    Vue.api.get('/category', {}, {
      before: () => this.loading = true,
      always: () => this.loading = false,
      callback: res => {
        this.$store.commit('setStylingCategories',  JSON.parse(JSON.stringify(res)));

        this.categories = [{
          id: 0,
          name: 'All',
          nodes: []
        }, ...res]
        this.categories.forEach(cat => {
          cat.slug = this.toSlug(cat.name)
        })

        this.$nextTick(() => {
          if (this.$refs['category-0']) this.$refs['category-0'][0].classList.add('active')
        })
      }
    })
  },
  methods: {
    toSlug (str) {
      return str.toString().toLowerCase().replace(/\s+/g, '-')
    },
    setActiveCategory (catId) {
      this.setCategory(catId)
      this.computedCategory.forEach(category => {
        if (category.id === catId) this.$refs['category-' + catId][0].classList.add('active')
        else this.$refs['category-' + category.id][0].classList.remove('active')
      })
      this.computedCategory.forEach(category => {
        category.nodes.forEach(sub => {
          this.$refs['subcategory-' + sub.id][0].classList.remove('active')
        })
      })
    },
    setActiveSubCategory (subId) {
      this.setCategory(subId)
      this.computedCategory.forEach(category => {
        category.nodes.forEach(sub => {
          if (sub.id === subId) this.$refs['subcategory-' + subId][0].classList.add('active')
          else this.$refs['subcategory-' + sub.id][0].classList.remove('active')
        })
      })
    },
    setCategory (id) {
      this.$emit('setCategory', id)
    }
  }
}
</script>

<style lang="less" scoped>
a, a:hover {
  text-decoration: none;
}

.router-link-active {
  font-weight: 600;
}

.list-toggler {
  position: absolute;
  top: 30px;
  right: 30px;

  &::after {
    content: "Collapse";
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid #aaa;
  }
}

.list-wrapper {
  margin: 0;
  overflow: hidden;
}

#list-toggler:checked ~ .list-wrapper {
  max-height: 0;
}
#list-toggler:checked ~ .list-toggler {
  &::after {
    content: "Expand";
  }
}

.menu {
  width: 250px;
  padding: 10px;
  border-radius: 8px;
  overflow: hidden;
}

.item {
  overflow: hidden;
  list-style: none;

  &.active {
    & > a {
      font-weight: 600;
    }
    .sub-menu {
      max-height: 30em;
    }
  }
}

.btn {
  display: block;
  padding: 6px 20px;
  position: relative;

  i {
    margin-right: 10px;
  }
}

.sub-menu {
  overflow: hidden;
  transition: all .4s ease-in-out;
  max-height: 0;

  a {
    display: block;
    padding: 10px 20px;
    margin: 4px 0;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      width: 6px;
      height: 100%;
      left: 0;
      top: 0;
      transition: .3s;
      opacity: 0;
    }

    &:hover {
      &:before {
        opacity: 1;
      }
    }

    &.active {
      font-weight: 500;
    }
  }
}

</style>
